import PropTypes from 'prop-types';
import { CircularProgress as MUICircularProgress } from '@material-ui/core';

function CircularProgress({ size }) {
  return <MUICircularProgress color="inherit" size={size} />;
}

CircularProgress.defaultProps = {
  size: 20,
};

CircularProgress.propTypes = {
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default CircularProgress;
